// extracted by mini-css-extract-plugin
module.exports = {"contact":"styles_contact__Nef8-","contactItem":"styles_contactItem__2q8d_"};